/* ==========================================================================
   SAVA — scroll reveal
   Adds .is-revealed to [data-yv-reveal] elements as they enter the viewport.
   ========================================================================== */
(function () {
  'use strict';

  var targets = document.querySelectorAll('[data-yv-reveal]');
  if (!targets.length) return;

  if (!('IntersectionObserver' in window)) {
    targets.forEach(function (el) { el.classList.add('is-revealed'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
  );

  targets.forEach(function (el) { observer.observe(el); });
})();

/* ==========================================================================
   SAVA — collection filters (progressive enhancement)
   Auto-submits the facets form on change; works as a plain GET form if JS
   is unavailable.
   ========================================================================== */
(function () {
  'use strict';

  var form = document.getElementById('FacetFiltersForm');
  if (!form) return;

  form.querySelectorAll('input[type="checkbox"], input[type="number"]').forEach(function (input) {
    input.addEventListener('change', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
  });

  var sortSelect = document.querySelector('[data-yv-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  }

  var toggleBtn = document.querySelector('[data-yv-toggle-facets]');
  var facets = document.getElementById('yv-facets');
  if (toggleBtn && facets) {
    toggleBtn.addEventListener('click', function () {
      facets.classList.toggle('is-open');
    });
  }
})();

/* ==========================================================================
   SAVA — quantity steppers
   Generic wiring for every .yv-qty widget on the page (product form, cart
   page line items). min="0" is respected where set (cart), otherwise floors
   at 1 (product form).
   ========================================================================== */
(function () {
  'use strict';

  document.querySelectorAll('.yv-qty').forEach(function (qty) {
    var input = qty.querySelector('[data-yv-qty-input]');
    var decrease = qty.querySelector('[data-yv-qty-decrease]');
    var increase = qty.querySelector('[data-yv-qty-increase]');
    if (!input || !decrease || !increase) return;

    var min = input.hasAttribute('min') ? parseInt(input.getAttribute('min'), 10) : 1;

    decrease.addEventListener('click', function () {
      var val = Math.max(min, (parseInt(input.value, 10) || min) - 1);
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    increase.addEventListener('click', function () {
      var val = (parseInt(input.value, 10) || min) + 1;
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
})();
